import { createApp, h } from 'vue'
import TemplateView from './components/TemplateView.vue'

let appInstance = null;

class TemplateViewElement extends HTMLElement {
  static get observedAttributes() {
    return ['uri', 'payload', 'preview'];
  }

  constructor() {
    super();
    this._app = null;
    this._uri = this.getAttribute('uri');
    this._payload = this.getAttribute('payload');
    this._preview = this.getAttribute('preview') === 'true';
  }

  connectedCallback() {
    if (!this._app) {
      const appOptions = {
        render: () => h(TemplateView, {
          uri: this._uri,
          payload: this._payload,
          onRouteTo: (event) => {
            this.dispatchEvent(new CustomEvent('route-to', { detail: event }));
          },
          onGoBack: () => {
            this.dispatchEvent(new CustomEvent('go-back'));
          },
        })
      };
  
      appInstance = createApp(appOptions);

      if (this._preview) {
        
        // Create an iframe
        this._iframe = document.createElement('iframe');
        this._iframe.style.border = 'none';
        this._iframe.style.width = '100%';
        this._iframe.style.height = '100%';
        
        this.appendChild(this._iframe);

        this._app = appInstance.mount(this._iframe.contentDocument.body);
      } else {
        this._app = appInstance.mount(this);
      }
    }
  }

  disconnectedCallback() {
    if (appInstance) {
      appInstance.unmount();
      appInstance = null;
      this._app = null;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'preview') {
      this._preview = newValue === 'true';
    }
  }
}

customElements.define('u-template-view', TemplateViewElement);

const app = createApp({});
app.mount('#app');

if (!window.routeTo) {
  window.routeTo = function (pageURL, pageKey = '') {
    // Global routing function - called from welcome page template

    const viewElements = document.getElementsByTagName('u-template-view');
    if (viewElements.length) {
      const viewElement = viewElements[0];
      viewElement.dispatchEvent(new CustomEvent('route-to', { detail: { pageURL, pageKey } }));
    }
  }
}

if (!window.goBack) {
  window.goBack = function () {
    // Called in child pages to go back to the welcome page
    console.log('goBack');

    const viewElements = document.getElementsByTagName('u-template-view');
    if (viewElements.length) {
      const viewElement = viewElements[0];
      viewElement.dispatchEvent(new CustomEvent('go-back'));
    }
  }
}

